
declare global {
  interface Window {
    SITE_CORE_URL: string;
    NODE_ENV?: string;
  }
}
const windowObj = typeof window !== 'undefined' ? window : {};
const {
  SITE_CORE_URL,
  NODE_ENV
} = windowObj as Window & typeof globalThis;

const {
  REACT_APP_SITE_CORE_URL,
  REACT_APP_NODE_ENV
} = process.env;

const SITE_CORE_BASE_URL = SITE_CORE_URL|| REACT_APP_SITE_CORE_URL ;
const ENV = NODE_ENV || REACT_APP_NODE_ENV;

export {
  SITE_CORE_BASE_URL,
  ENV
}